module.exports = {
    companyName : "中国科学院大学",
}